import React from 'react';

function MessageHub() {
  return <div></div>;
}

export default MessageHub;
